import * as cookie from 'cookie';
import React from 'react';
import {
  BASE_URL,
  DEFAULT_LOCATION,
  PRODUCT_DETAILS,
  UPDATE_ZONE,
  API_MYASTER_URL
} from 'aster-foundation/core/common/utils/ApiConst';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { parse } from 'url';
import Footer from '@common/Component/Footer/Footer';
import Header from '@common/Component/Header/Header';
import HereToHelp from '@common/Component/HereToHelp/HereToHelp';
import TopBar from '@common/Component/TopBar/TopBar';
import ProductDetails from 'Epharmacy/ProductDetails/ProductDetails';


import { getApiAuthHeader, getConfigurationValue, getHomePageJson, getIsInstoreApp, getReferralPageForGA, getGuestToken, getRegionLangTimezoneFromUrl } from '@common/Utility/common-utils';
import { HOME_PAGE_JSON_FILE_NAME, ONLINE_PHARMACY_ROUTE, PHARMACY_REDIRECT_FLAG } from '@common/Utility/constants';
import EpharmacyContext from '@common/Context/EpharmacyContext';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { getConfigurationData } from '../../../../../RxHomeDelivery/utils';
import { MY_ASTER_CATEGORY, PAGE_NAME } from '@common/Constants/analytics';
import { getLangRegionCodeByPathName } from '@common/i18n/utility';
import { useSetCommonParams } from '@common/Utility/analytics-common';

export async function getServerSideProps(context) {
  const cookies = cookie.parse(context.req.headers.cookie || '', { decode: true });

  const refPageString = context?.req?.headers?.referer?.split('/');
  const referrerPage = getReferralPageForGA(refPageString);
  const regexPattern = /^\/online-pharmacy\/p\/\d+$/;
  const { req } = context;
  const parsedUrl = parse(req.url, true);
  const pathname = parsedUrl?.pathname;

  const deviceId = uuidv4();
  let accessToken = cookies?.kcToken ? `Bearer ${Buffer.from(cookies.kcToken, 'base64')}` : '';
  if (typeof accessToken === 'undefined' || !accessToken) {
    try {
      const guestToken = await getGuestToken(deviceId);
      accessToken = `guest-token ${guestToken}`;
    } catch (e) {
      accessToken = '';
    }
  }

  let result = [];
  let apiEndPoint;
  let zoneData = cookies?.userZone;
  if (typeof cookies?.userZone === 'undefined' || !cookies?.userZone) {
    const address = await fetch(BASE_URL + DEFAULT_LOCATION(getLangRegionCodeByPathName("region", pathname)?.toUpperCase()), {
      headers: getApiAuthHeader({
        Authorization: accessToken,
        deviceId,
      }),
    }).then((response) => response?.json());

    const latLong = address?.data?.[0]?.latLong?.split(/\s+/)?.join('')?.split(',');
    const data = {
      latitude: latLong?.[0],
      longitude: latLong?.[1],
    };

    const getZoneData = await fetch(BASE_URL + UPDATE_ZONE, {
      method: 'POST',
      headers: getApiAuthHeader({
        Authorization: accessToken,
        deviceId,
      }),
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((err) => console.log(err));

    zoneData = getZoneData?.data?.join(',');
  }

  try {
    const productURLKey = context?.query?.product;
    let param = '';
    apiEndPoint = `${API_MYASTER_URL + PRODUCT_DETAILS}${productURLKey[productURLKey.length - 1]}?`;
 
    if (context?.query?.categoryId) {
      param += `categoryId=${context?.query?.categoryId}&`;
      if (context?.query?.isFromRecentSearch) {
        param += `isFromRecentSearch=true&`;
      }
    }
 
    if (zoneData) {
      param += `zone=${zoneData}`;
    }
    const {region, lang, timezone} = getRegionLangTimezoneFromUrl(context?.resolvedUrl);
    result = await fetch(apiEndPoint + param, {
      headers: getApiAuthHeader({
        Authorization: accessToken,
        deviceId,
        'x-country-code': region,
        'x-site-time-zone': timezone,
        'x-language': lang,
      }),
    }).then((res) => res?.json());
    // result = await productRes.json();
  } catch (e) {
    result = [];
  }
  const configurationData = await fetch(BASE_URL + getConfigurationData, {
    headers: getApiAuthHeader({
      Authorization: accessToken,
      deviceId,
    }),
  }).then((res) => res?.json());

  const redirectionFlag = getConfigurationValue(configurationData?.data, PHARMACY_REDIRECT_FLAG);
  const isRedirectEnabled = redirectionFlag ? JSON.parse(redirectionFlag) : false;

  const productDetails = result?.body ? result?.body : {};
  const redirectParam = `${ONLINE_PHARMACY_ROUTE}${productDetails?.productUrl}`;
  EventEmitter.dispatch('canonical_url', redirectParam);
  const homePageSeoData = await getHomePageJson(HOME_PAGE_JSON_FILE_NAME.WEB);
    if (regexPattern.test(pathname) && isRedirectEnabled) {
      return {
        props: { productDetails, homePageSeoData, headerData: { search: true, mobileSearch: true }, referrerPage }, 
        redirect: {
          permanent: true,
          destination: redirectParam
        }
      };
    } else {
      return {
        props: { productDetails, homePageSeoData, headerData: { search: true, mobileSearch: true }, referrerPage }
      };
    }
}

const Product = (props) => {
  const [isFirstCalled, setIsFirstCalled] = React.useState(true);
  useSetCommonParams({ screen: props?.productDetails?.name, page: PAGE_NAME.PDP_AE, category: MY_ASTER_CATEGORY.AE });

  return (
    <div className="page_PDP">
      <EpharmacyContext.Provider value={{ epharmacySearch: true, pageName: 'Product Details Page' }}>
        <TopBar
          screenName={props?.productDetails?.name} 
          pageType={PAGE_NAME?.PDP_AE}
        />
        <Header
          search={props?.headerData?.search}
          mobileSearch={props?.headerData?.mobileSearch}
          screenName={props?.productDetails?.name} 
          pageType={PAGE_NAME?.PDP_AE}
          customOuterClass="searchPageHeader"
        />

        <ProductDetails
          productDetails={Object.keys(props?.productDetails).length > 0 ? props?.productDetails : undefined}
          homePageSeoData={props?.homePageSeoData}
          referrerPage={props?.referrerPage}
          isFirstCalled={isFirstCalled}
          setIsFirstCalled={setIsFirstCalled}
        />
      </EpharmacyContext.Provider>
      {!getIsInstoreApp() && <HereToHelp customClass="page_pdp_hereToHelp" />}
      <Footer screenName={props?.productDetails?.name} pageType={PAGE_NAME?.PDP_AE} classCustomName="pdp-mobile-btm-spacing page_pdp_footer" />
    </div>
  );
};

Product.propTypes = {
  productDetails: PropTypes.object,
  homePageSeoData: PropTypes.object,
  headerData: PropTypes.object,
  referrerPage: PropTypes.string,
};
Product.defaultProps = {
  productDetails: {},
  homePageSeoData: {},
  headerData: {},
  referrerPage: '',
};
export default Product;
